/**
 * Staff filters. Search, audience and type stay visible. The rest waits under More filters.
 */

import React, { useState } from 'react';

function Field({ id, label, children }) {
  return (
    <label className="rf-label" htmlFor={id}>
      {label}
      {children}
    </label>
  );
}

export default function TicketFilters({ filters, facets, meta, onChange }) {
  const [more, setMore] = useState(false);
  const set = (key) => (event) => onChange({ ...filters, [key]: event.target.value });

  return (
    <div className="support-filters-panel">
      <div className="support-filters-primary">
        <Field id="support-search" label="Search">
          <input
            id="support-search"
            className="rf-input"
            value={filters.q}
            onChange={set('q')}
            placeholder="Subject, person, or ticket number"
          />
        </Field>
        <Field id="support-audience" label="Who">
          <select id="support-audience" className="rf-input" value={filters.audience} onChange={set('audience')}>
            <option value="">Everyone</option>
            {(meta?.audiences || []).map((item) => (
              <option key={item.id} value={item.id}>{item.label}</option>
            ))}
          </select>
        </Field>
        <Field id="support-type" label="Type">
          <select id="support-type" className="rf-input" value={filters.type} onChange={set('type')}>
            <option value="">All types</option>
            {(meta?.types || []).map((item) => (
              <option key={item.id} value={item.id}>{item.label}</option>
            ))}
          </select>
        </Field>
        <button type="button" className="rf-btn rf-btn-ghost" onClick={() => setMore((open) => !open)}>
          {more ? 'Fewer filters' : 'More filters'}
        </button>
      </div>
      {more && (
        <div className="support-filters-more">
          <Field id="support-org" label="Organisation">
            <select id="support-org" className="rf-input" value={filters.orgId} onChange={set('orgId')}>
              <option value="">All organisations</option>
              {facets?.noOrg && <option value="none">No organisation</option>}
              {(facets?.orgs || []).map((org) => (
                <option key={org.id || org.name} value={org.id || org.name}>{org.name}</option>
              ))}
            </select>
          </Field>
          <Field id="support-requester" label="Person">
            <select id="support-requester" className="rf-input" value={filters.requester} onChange={set('requester')}>
              <option value="">Anyone</option>
              {(facets?.requesters || []).map((person) => (
                <option key={person.email} value={person.email}>{person.name}</option>
              ))}
            </select>
          </Field>
          <Field id="support-assignee" label="Assignee">
            <select id="support-assignee" className="rf-input" value={filters.assignee} onChange={set('assignee')}>
              <option value="">Anyone</option>
              <option value="none">Unassigned</option>
              {(meta?.staff || []).map((person) => (
                <option key={person.email} value={person.email}>{person.name}</option>
              ))}
            </select>
          </Field>
          <Field id="support-product" label="Product">
            <select id="support-product" className="rf-input" value={filters.product} onChange={set('product')}>
              <option value="">All products</option>
              {(meta?.products || []).map((item) => (
                <option key={item.id} value={item.id}>{item.label}</option>
              ))}
            </select>
          </Field>
          <Field id="support-priority-filter" label="Priority">
            <select id="support-priority-filter" className="rf-input" value={filters.priority} onChange={set('priority')}>
              <option value="">Any priority</option>
              {(meta?.priorities || []).map((item) => (
                <option key={item.id} value={item.id}>{item.label}</option>
              ))}
            </select>
          </Field>
          <Field id="support-tag-filter" label="Tag">
            <input id="support-tag-filter" className="rf-input" list="support-filter-tags" value={filters.tag} onChange={set('tag')} />
            <datalist id="support-filter-tags">
              {(meta?.tags || []).map((item) => <option key={item.slug} value={item.slug}>{item.label}</option>)}
            </datalist>
          </Field>
          <Field id="support-from" label="Opened from">
            <input id="support-from" className="rf-input" type="date" value={filters.from} onChange={set('from')} />
          </Field>
          <Field id="support-to" label="Opened to">
            <input id="support-to" className="rf-input" type="date" value={filters.to} onChange={set('to')} />
          </Field>
          <Field id="support-rating-filter" label="Rating">
            <select id="support-rating-filter" className="rf-input" value={filters.rating} onChange={set('rating')}>
              <option value="">Any rating</option>
              <option value="good">Good</option>
              <option value="bad">Bad</option>
              <option value="none">Not rated</option>
            </select>
          </Field>
          <label className="support-check">
            <input
              type="checkbox"
              checked={filters.overdue === '1'}
              onChange={(event) => onChange({ ...filters, overdue: event.target.checked ? '1' : '' })}
            />
            Overdue first reply
          </label>
        </div>
      )}
    </div>
  );
}
